import script from "./BlockTransactionPaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockTransactionPaymentMethod.vue?vue&type=script&setup=true&lang=js"

import "./BlockTransactionPaymentMethod.vue?vue&type=style&index=0&id=b76472ec&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b76472ec"]])

export default __exports__